// Design-system reminder: every title uses a typography.h* preset, OR `font-heading font-bold`.
import React from "react";
import LandingNavbar from "../landing/LandingNavbar";
import Footer from "../landing/Footer";
import { typography, surfaces, textColors, brandColors } from "../../design-system/tokens";
import PartnerTermsContent, {
  PARTNER_TERMS_LAST_UPDATED,
  PARTNER_TERMS_VERSION,
} from "./PartnerTermsContent";

const PartnerTermsOfUse = () => {
  return (
    <div className={`min-h-screen ${surfaces.secondary} flex flex-col`}>
      <LandingNavbar />

      <div className="flex-1 pt-16">
        <div className={`bg-gradient-to-r ${brandColors.gradientFrom} ${brandColors.gradientTo} text-white`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center">
              <h1 className={typography.h1Dark}>Partner Program Terms of Use</h1>
              <p className={`${typography.bodyLargeDark} mt-4`}>
                Version {PARTNER_TERMS_VERSION} — last updated {PARTNER_TERMS_LAST_UPDATED}
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className={`${surfaces.primary} rounded-lg shadow-md p-8`}>
            <p className={`${typography.bodySmall} ${textColors.muted} mb-6`}>
              These terms apply to partners in the myvitae.ai partner program. If you use myvitae.ai
              as a customer, the general{" "}
              <a href="/terms" className="underline">
                Terms of Use
              </a>{" "}
              also apply.
            </p>
            <PartnerTermsContent />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PartnerTermsOfUse;
